import React from "react";
import {
  Typography,
  Row,
  Col,
  Breadcrumb,
  Card,
  Table,
  Tag,
  Statistic,
  Spin,
} from "antd";
import { WalletOutlined } from "@ant-design/icons";
import { useGetWalletHistoryQuery ,useGetMyTotalBalanceQuery} from "../../slices/paymentApiSlice";

const { Title } = Typography;

const WalletHistoryPage = ({ darkmode }) => {
  const { data: txData, isLoading: txLoading } =
    useGetWalletHistoryQuery();

  const { data: balanceData, isLoading: balanceLoading } =
    useGetMyTotalBalanceQuery();

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type) =>
        type === "credit" ? (
          <Tag color="green">CREDIT</Tag>
        ) : (
          <Tag color="red">DEBIT</Tag>
        ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amount, record) =>
        record.type === "credit" ? (
          <span style={{ color: "green", fontWeight: 600 }}>
            + ₹ {amount}
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: 600 }}>
            - ₹ {amount}
          </span>
        ),
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (date) => new Date(date).toLocaleString(),
    },
     {
      title: "status",
      dataIndex: "status",
      render: (status, record) =>
        record.status === "approved" ? (
          <span style={{ color: "green", fontWeight: 600 }}>
            {status}
          </span>
        ) : (
          <span style={{ color: "red", fontWeight: 600 }}>
            {status}
          </span>
        ),
    },
  ];

  return (
    <>
      <Title
        style={{ fontFamily: "Inter, sans-serif", marginBottom: "16px" }}
        level={2}
      >
        <WalletOutlined /> Wallet History
      </Title>

      {/* <Row
        style={{
          padding: "20px",
          backgroundColor: darkmode ? "#141414" : "#FFF",
          borderRadius: "5px",
          marginBottom: "20px",
        }}
      >
        <Col flex="auto">
          <Breadcrumb
            items={[{ title: "Finance" }, { title: "Wallet" }]}
          />
        </Col>
      </Row> */}

      {/* Balance Card */}
      <Card
        style={{ marginBottom: "20px" }}
        loading={balanceLoading}
      >
        <Statistic
          title="Available Balance"
          value={balanceData?.balance || 0}
          precision={2}
          prefix="₹"
          valueStyle={{
            color: balanceData?.balance >= 0 ? "#3f8600" : "#cf1322",
          }}
        />
      </Card>

      {/* Transaction Table */}
      <Card title="Transaction History">
        <Table
          columns={columns}
          dataSource={txData?.data || []}
          loading={txLoading}
          rowKey="_id"
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default WalletHistoryPage;